import { defineComponent, computed, resolveComponent, openBlock, createElementBlock, normalizeClass, createBlock, withCtx, renderSlot } from "vue";
import { getPrefixCls } from "../../_utils/global-config.js";
import Checkbox from "../../checkbox/index.js";
import _export_sfc from "../../_virtual/plugin-vue_export-helper";
const _sfc_main = defineComponent({
  name: "Option",
  components: {
    Checkbox
  },
  props: {
    value: [String, Number],
    label: String,
    disabled: Boolean,
    tagProps: {
      type: Object
    },
    isSelected: Boolean,
    isActive: Boolean,
    multiple: Boolean
  },
  emits: ["click", "mouseenter", "mouseleave"],
  setup(props, { emit }) {
    const prefixCls = getPrefixCls("dropdown-option");
    const handleClick = (e) => {
      if (!props.disabled) {
        emit("click", props.value, e);
      }
    };
    const handleMouseEnter = (e) => {
      if (!props.disabled) {
        emit("mouseenter", props.value, e);
      }
    };
    const handleMouseLeave = (e) => {
      if (!props.disabled) {
        emit("mouseleave", props.value, e);
      }
    };
    const cls = computed(() => [
      prefixCls,
      {
        [`${prefixCls}-disabled`]: props.disabled,
        [`${prefixCls}-selected`]: props.isSelected,
        [`${prefixCls}-active`]: props.isActive,
        [`${prefixCls}-multiple`]: props.multiple
      }
    ]);
    return {
      prefixCls,
      cls,
      handleClick,
      handleMouseEnter,
      handleMouseLeave
    };
  }
});
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_checkbox = resolveComponent("checkbox");
  return openBlock(), createElementBlock("li", {
    class: normalizeClass(_ctx.cls),
    onClick: _cache[0] || (_cache[0] = (...args) => _ctx.handleClick && _ctx.handleClick(...args)),
    onMouseenter: _cache[1] || (_cache[1] = (...args) => _ctx.handleMouseEnter && _ctx.handleMouseEnter(...args)),
    onMouseleave: _cache[2] || (_cache[2] = (...args) => _ctx.handleMouseLeave && _ctx.handleMouseLeave(...args))
  }, [
    _ctx.multiple ? (openBlock(), createBlock(_component_checkbox, {
      key: 0,
      class: normalizeClass(`${_ctx.prefixCls}-checkbox`),
      "model-value": _ctx.isSelected,
      disabled: _ctx.disabled
    }, {
      default: withCtx(() => [
        renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["class", "model-value", "disabled"])) : renderSlot(_ctx.$slots, "default", { key: 1 })
  ], 34);
}
var DropDownOption = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);
export { DropDownOption as default };
